import { render, staticRenderFns } from "./tempMsgDetails.vue?vue&type=template&id=6743d80e&scoped=true&"
import script from "./tempMsgDetails.vue?vue&type=script&lang=js&"
export * from "./tempMsgDetails.vue?vue&type=script&lang=js&"
import style0 from "./tempMsgDetails.vue?vue&type=style&index=0&id=6743d80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6743d80e",
  null
  
)

component.options.__file = "tempMsgDetails.vue"
export default component.exports